import { Component, inject } from '@angular/core';
import { AEtrTradeProvider } from '../../common/providers/a-etr-trade.provider';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { OpenTradeBaseComponent } from '../open-trade-base.component';

@Component({
  standalone: true,
  selector: 'app-a-etr-trade',
  templateUrl: './a-etr-trade.component.html',
  styleUrls: ['./a-etr-trade.component.scss'],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    SharedModule,
    DatePickerComponent,
    FormsModule,
    TooltipModule,
  ],
  providers: [AEtrTradeProvider],
})
export class AEtrTradeComponent extends OpenTradeBaseComponent {
  readonly #aEtrTradeProvider = inject(AEtrTradeProvider);

  aEtrTradeForm: FormGroup;

  protected override onInitialize(): void {
    if (this.isEditTrade) {
      this.componentService.pageTitle.set('Edit a Trade');
    }
    this.#aEtrTradeProvider.initForm({ ...this.currentData, type: this.type });
    this.aEtrTradeForm = this.#aEtrTradeProvider.aEtrTradeForm;
  }

  protected override getMainForm(): FormGroup {
    return this.aEtrTradeForm;
  }

  get form2TradeDocumentsControl() {
    return this.getTradeDocumentsControl(this.aEtrTradeForm);
  }

  override fileChange(element: Event, acronym: string): void {
    super.fileChange(element, acronym, this.aEtrTradeForm);
  }

  selectCreditor(event: any): void {
    if (event) {
      this.showTradeDocumentForEdit(
        event,
        this.aEtrTradeForm,
        event?.requiredTradeDocTypes,
      );
    }
  }

  onSubmit(): void {
    if (this.aEtrTradeForm.invalid) return;
    this.submitFormData(this.aEtrTradeForm.getRawValue());
  }
}
